import { render } from "./WaitForCounselor.vue?vue&type=template&id=cca7427c&scoped=true"
import script from "./WaitForCounselor.vue?vue&type=script&lang=js"
export * from "./WaitForCounselor.vue?vue&type=script&lang=js"

import "./WaitForCounselor.vue?vue&type=style&index=0&id=cca7427c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca7427c"]])

export default __exports__